// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"021db608","667":"afd2f00b"}[chunkId] + ".chunk.js";
};